import { render, staticRenderFns } from "./certifyQuery.vue?vue&type=template&id=c7f2bdd0"
import script from "./certifyQuery.vue?vue&type=script&lang=js"
export * from "./certifyQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports